import { render, staticRenderFns } from "./DashboardLauncher.vue?vue&type=template&id=2b79ebe4&"
import script from "./DashboardLauncher.vue?vue&type=script&lang=js&"
export * from "./DashboardLauncher.vue?vue&type=script&lang=js&"
import style0 from "./DashboardLauncher.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports